export enum DialogRole {
	Submit = 'submit',
	Cancel = 'cancel'
}
